// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"d17b2ebf","453":"96c2bb60","806":"55dbdbda"}[chunkId] + ".chunk.js";
};